module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-214.7be9709a.svg";